export const strings = {
  title: 'マシン通知履歴',
}

export const machineErrorsTableContent = [
  '',
  'ID',
  'ステーションID',
  'マシンID',
  'オーダーID',
  '通知コード',
  'エラーレベル',
  'メッセージ',
  '発生日時',
]
